import React, { useState } from 'react';
import { ToolKitFilter } from './ToolKitFilter';

// Dummy function if not set.
function defaultLabelFunction(input) {
	return input.charAt(0).toUpperCase() + input.slice(1);
}

export function Accordion(props) {
	const showItemCount = 4;
	const [isOpen, setIsOpen] = useState(false);
	const [showAllOptions, setShowAllOptions] = useState(false);

	let labelFunction = props.labelFunction;
	if (typeof props.labelFunction !== 'function') {
		labelFunction = defaultLabelFunction;
	}

	const selectAllChecked = () => {
		return props.selectedOptions.length === props.options.length ? 'checked' : '';
	}

	const moreItemCount = () => {
		if ( showAllOptions || props.options.length <= showItemCount ) {
			return 0;
		}
		return props.options.length - showItemCount;
	}

	const toggleAccordion = () => {
		setIsOpen( ! isOpen );
	}

	const showAll = (event) => {
		event.preventDefault();
		setShowAllOptions(true);
	}

	const showLess = (event) => {
		event.preventDefault();
		setShowAllOptions(false);
	}

	const getOptions = () => {
		let options = props.options;
		if (! Array.isArray(props.options)) {
			options = [];
		}
		if ( ! showAllOptions ) {
			return options.slice(0, showItemCount)
		}
		return options;
	}

	const className = 'toolkit-fitler' + ( isOpen ? ' toolkit-filter--active' : '' );
	return (
		<div className={className}>
			<p onClick={toggleAccordion}>{ props.label }</p>
			{ ! isOpen && props.selectedOptions.length > 0 && (
				<div className="toolkit-filter--summary">
					{props.selectedOptions.map((option, index) => (
						<>
							<span key={index}>{labelFunction(option)}</span>
							<br />
						</>
					))}
				</div>
			)}
			<ToolKitFilter
				id={'accordion-' + props.id}
				selectAllChecked={selectAllChecked}
				label={props.label}
				onChangeCallback={props.onChangeCallback}
				className='toolkit-filter--options'
				allCount={props.allCount}
				options={getOptions()}
				optionsCount={props.options.length}
				selectedOptions={props.selectedOptions}
				labelFunction={labelFunction}
			/>
			<ol className='toolkit-filter--options'>
				{moreItemCount() > 0 ? (
					<li key="actions">
						<a className="d-flex align-items-center show-more-less" onClick={showAll}>
							+ {moreItemCount()} more
						</a>
					</li>
				) : props.options.length >
				showItemCount && (
					(
						<li key="actions">
							<a className="d-flex align-items-center show-more-less" onClick={showLess}>
								Show less
							</a>
						</li>

					)
				)}
			</ol>
		</div>
	);
}

export default Accordion;
